import Component from '../core/Component'
import { format } from '../utils/Number'

export default class More extends Component {
    constructor(element) {
        super(element);

        let options = {};
        if (this.element.dataset.options != null) {
            options = JSON.parse(this.element.dataset.options);
        }
        let defaults = {
            large: false,
            color: "#000000",
        }

        this.options = {
            ...defaults,
            ...options
        }

        this.lang = document.documentElement.getAttribute('lang') ? document.documentElement.getAttribute('lang') : "cs";

        if (this.lang === "en") {
            this.labels = {
                men: "Men",
                women: "Women",
                estimated: "estimated"
            }
        } else if (this.lang === "cs") {
            this.labels = {
                men: "Muži",
                women: "Ženy",
                estimated: "odhad"
            }
        }
    }

     async require() {
        this.Chart = await import('chart.js');
     }

    prepare() {
        let labels = [];
        let data = [];
        let dataset = null
        let datasets = null

        if (this.element.id == 'chart-car-km') {
            labels = ["2013","2014", "2015", "2016", "2017"];
            data = [1628000, 1379195, 1395552, 1270615, 1229390];
        } else if(this.element.id == 'chart-car-emission') {
            labels = ["2013","2014","2015", "2016", "2017"];
            data = [301369,252824,257677, 235602, 221973];
        } else if(this.element.id == 'chart-airplane-km') {
            labels = ["2013","2014","2015", "2016", "2017" ];
            data = [2123609,2307653,2226050, 2942647, 2766557];
        } else if(this.element.id == 'chart-airplane-emission') {
            labels = ["2013","2014","2015", "2016", "2017"];
            data = [248171,263152,259731, 637891, 595990];
        } else if(this.element.id == 'chart-train-km') {
            labels = ["2013","2014","2015", "2016", "2017"];
            data = [155667,133021,93222, 203108, 204255];
        } else if(this.element.id == 'chart-train-emission') {
            labels = ["2013","2014","2015", "2016", "2017"];
            data = [4296,3671,2573, 2466, 2502];
        } else if(this.element.id == 'chart-paper') {
            labels = ["2013","2014","2015", "2016","2017"];
            data = [4646554,4397377,4632930, 4078850, 3215750];
        } else if(this.element.id == 'chart-grants') {
            labels = ["2013","2014", "2015", "2016", "2017", "2018"];
            dataset = [
                {
                    yAxisID: 'A',
                    data: [354400,408118, 282305, 377630, 387600, 533609],
                    position: 'left',
                    backgroundColor: "#7E4396",
                    labelString: 'tets'
                },
                {
                    yAxisID: 'B',
                    data: [25,25, 25, 19, 20, 24],
                    position: 'right',
                    backgroundColor: "#D8C6DF",
                    labelString: 'tets'
                }
            ]
        } else if(this.element.id == 'chart-matching') {
            labels = ["2016", "2017", "2018"];
            dataset = [
                {
                    yAxisID: 'A',
                    data: [390060, 390760, 337495],
                    position: 'left',
                    backgroundColor: "#7E4396",
                    labelString: 'tets'
                },
                {
                    yAxisID: 'B',
                    data: [8, 7, 4],
                    position: 'right',
                    backgroundColor: "#D8C6DF",
                    labelString: 'tets'
                }
            ]
        } else if(this.element.id == 'chart-green-company') {
            labels = ["2016", "2017", "2018"];
            data = [105.15, 123.65, 167];
        } else if(this.element.id == 'chart-diversity1') {
            labels = ["Audit", "Tax", "AS&P", "Management Consulting", "Deals", "Risk Consulting", "KPMG Legal", "Infrastruktura"];
            dataset = [
                {
                    data: [219, 168, 84, 48, 6, 57, 23, 102],
                    backgroundColor: "#7E4396",
                    label: "ženy"
                },
                {
                    data: [158, 44, 8, 103, 18, 54, 16, 40],
                    backgroundColor: "#9E3876",
                    label: "muži"
                }
            ]
        }
        else if(this.element.id == 'chart-diversity1Aj') {
            labels = ["Audit", "Tax", "AS&P", "Management Consulting", "Deals", "Risk Consulting", "KPMG Legal", "Infrastruktura"];
            dataset = [
                {
                    data: [219, 168, 84, 48, 6, 57, 23, 102],
                    backgroundColor: "#7E4396",
                    label: "women"
                },
                {
                    data: [158, 44, 8, 103, 18, 54, 16, 40],
                    backgroundColor: "#9E3876",
                    label: "men"
                }
            ]
        } else if(this.element.id == 'chart-diversity2') {
            labels = ["Partner", "Director", "Senior Manager", "Manager", "Specialist, Supervisor", "Assistant"];
            dataset = [
                {
                    data: [5, 3, 18, 29, 420, 232],
                    backgroundColor: "#7E4396",
                    label: "ženy"
                },
                {
                    data: [24, 16, 36, 55, 181, 129],
                    backgroundColor: "#9E3876",
                    label: "muži"
                }
            ]
        }
        else if(this.element.id == 'chart-diversity2Aj') {
            labels = ["Partner", "Director", "Senior Manager", "Manager", "Specialist, Supervisor", "Assistant"];
            dataset = [
                {
                    data: [5, 3, 18, 29, 420, 232],
                    backgroundColor: "#7E4396",
                    label: "women"
                },
                {
                    data: [24, 16, 36, 55, 181, 129],
                    backgroundColor: "#9E3876",
                    label: "men"
                }
            ]
        }else if(this.element.id == 'chart-sport') {
            labels = ["Darované vstupné z odborných fór", "Zaměstnanecké granty", "Sportovní turnaje", "Interní zaměstnanec sbírka", "Matchingový fond", "Podpora vzdělávání k podnikání", "Dary"];
            data = [461810, 533609, 160300, 337495, 339255, 394251, 169700];
        }

        var canvas = document.createElement('canvas');
        this.element.appendChild(canvas);
        var ctx = canvas.getContext("2d");
        var maintainAspectRatio = true;

        if(this.element.id == 'chart-grants' || this.element.id == 'chart-grants2') {
            canvas.height = 200;
            maintainAspectRatio = false;
        }

        let yAxes = [{
            ticks: {
                beginAtZero:true,
                fontColor: 'black',
                fontStyle: "bold",
                callback: function(value, index, values) {
                    return typeof value === 'number' ? format(value) : value
                }
            }
        }]

        if (dataset) {
            datasets = dataset
            if (datasets.filter(item => item.yAxisID).length > 1) {
                yAxes = datasets.map(dataset => ({
                    id: dataset.yAxisID,
                    ...yAxes[0],
                    position: dataset.position,
                    labelString: dataset.labelString
                }))
            }
        } else {
            datasets = [
                {
                    data: data,
                    backgroundColor: this.options.color,
                    borderColor: this.options.color,
                    borderWidth: 1
                }
            ]
        }

        this.myBar = new this.Chart(ctx, {
            type: 'bar',
            data: {
                labels: labels,
                datasets: datasets,
            },
            options: {
                maintainAspectRatio: maintainAspectRatio,
                responsive: true,
                legend: {
                     display: false,
                },
                scales: {
                    xAxes: [{
                        barPercentage: this.options.large ? 0.6 : 0.2,
                        ticks: {
                            fontColor: 'black',
                            fontStyle: "bold",
                            autoSkip: false
                        }
                    }],
                    yAxes: yAxes
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./components/Graphs.js